<div
  ngbDropdown
  #optionsMenu="ngbDropdown"
  placement="bottom-right"
  container="body"
  (openChange)="isDropdownOpen = $event">
  <button
    type="button"
    ngbDropdownAnchor
    [ngClass]="{ loaded: loaded }"
    class="{{ colour }} {{ size }} position-relative"
    [disabled]="disabled || isLoading"
    [class.hover]="isDropdownOpen"
    [style.width]="width"
    (click)="!disabled && optionsMenu.toggle()">
    <img [class.invisible]="isLoading" [class]="size" *ngIf="leftIconSrc" [src]="leftIconSrc" alt="" />
    <div [class.invisible]="isLoading">
      <ng-content></ng-content>
    </div>
    <img
      [class]="size"
      [class.invisible]="isLoading"
      [src]="isDropdownOpen ? '/assets/icons/white/Chevron Up.svg' : '/assets/icons/white/Chevron Down.svg'"
      alt="" />
    <img *ngIf="isLoading" class="loading-icon" src="assets/icons/white/Loading.svg" alt="loading" i18n-alt />
  </button>
  <div ngbDropdownMenu class="dropdown-container" [style.max-height]="menuMaxHeight">
    <div
      class="ngb-dropdown-item"
      ngbDropdownItem
      *ngFor="let item of dropdownItems"
      [class.text-start]="itemAlign === 'start'"
      (click)="itemSelected.emit(item)">
      {{ item.label }}
    </div>
  </div>
</div>
